import React from 'react';
import { Button } from '@roger/ui-components';
import { useNavigate } from 'react-router-dom';
import X12_837I_Testing from '../components/X12_837I_Testing';

const TestingX12_837: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='container mx-auto p-6 space-y-6'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center space-x-4'>
          <Button
            variant='outline'
            onClick={() => navigate('/testing')}
            className='flex items-center space-x-2'
          >
            <span>←</span>
            <span>Back to Testing</span>
          </Button>
          <div>
            <h1 className='text-3xl font-bold'>X12 837 Testing</h1>
            <p className='text-muted-foreground'>
              Test X12 837 healthcare claim submission
            </p>
          </div>
        </div>
      </div>

      <X12_837I_Testing />
    </div>
  );
};

export default TestingX12_837;
